
    import Vue from "vue";
    import AllocationCheckInTimeModal from "@/views/Modals/BookingsModals/AllocationCheckInTimeModal.vue"
    import MapLocationModal from "@/views/Modals/BookingsModals/MapLocationModal.vue";
    import AllocationDateModal from "@/views/Modals/BookingsModals/AllocationDateModal.vue"
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import * as toastr from "toastr";
    import { ApiClient } from "@/utilities/ApiClient";
    import { BookingVM } from "@/model/Api/VM/BookingVM";
    import { Prop } from "vue-property-decorator";
    import { IBookingAllocation } from "@/model/BookingAllocation";
    import vuescroll from "vuescroll";
    import { Utils } from "@/utilities/Utils";
    import Loader from "@/views/Loader.vue"
import { BookingHotelVM } from "@/model/Api/VM/BookingHotelVM";

    @Component({
        components: {
            AllocationCheckInTimeModal,
            AllocationDateModal,
            ApiButton,
            Loader,
            MapLocationModal
        }
    })

    export default class AllocationTab extends Vue {


        ops = {
            // The following configurations correspond to different parts of Vuescroll.
            bar: {
                background: 'none',
                disable: true
            }
        }

        //
        // -- properties
        //

        @Prop({}) private booking !: BookingVM;
        @Prop({}) private hotels !: Array<BookingHotelVM>;
        selectedHotel: number = 0;
        selectedBookingID: number = -1; // unallocated uses 0 as an id so we need another number to respresent a 'blank' hotel ID
        private loaderActive: boolean = false;

        friendlyURL(url: string) {
            var lc = url.toLowerCase();
            var isMatch = lc.substring(0, 8) == 'https://' || lc.substring(0, 7) == 'http://';
            if (isMatch) return url
            else return `https://${url}`
        }

        friendlyWebAddress(url: string) {
            return url.replace(/(.{20})..+/, "$1…");
        }

        async openMap(hotelLat: number, hotelLng: number,) {
            const dialogue = this.$refs.mapLocationModal as MapLocationModal & { show: () => void };
            dialogue.show(hotelLat, hotelLng, true);
        }

        private get isDisabled() {
            let retVal = 0

            if (this.booking.statusID === 3) { retVal = 1 }
            if (this.booking.statusID === 5) { retVal = 1 }
            if (this.booking.statusID === 6) { retVal = 1 }
            if (this.booking.statusID === 8) { retVal = 1 }
            return retVal;
        }

        private async updatePreferred(hotel: BookingHotelVM) {
            const response = await ApiClient.post("/Api/Booking/preferredHotel", hotel);
            if (response.message != "ok") {
                toastr.error("Error");
            }
            else {
                this.$emit("loadHotels");
                this.$emit("loadBooking");
                this.$emit("noRequireSave");                
            }
        }


    }
